import api from "../api";

export const getUsers = (data) => {
  return api.getApi().get(api.getBaseUrl() + "users");
};
export const getUser = (id) => {
  return api.getApi().get(api.getBaseUrl() + "users/" + id);
};
export const createUser = (data) => {
  return api.getApi().post(api.getBaseUrl() + "users", data);
};

export const updateUser = (id, data) => {
  console.log("data", id);
  return api.getApi().put(api.getBaseUrl() + "users/" + id, data);
};
export const getProfile = () => {
  return api.getApi().get(api.getBaseUrl() + "profile");
};

export const deleteUser = (id) => {
  return api.getApi().delete(api.getBaseUrl() + "users/" + id);
};

export const getUsersForTasks = () => {
  return api.getApi().get(api.getBaseUrl() + "users-for-tasks");
};

export const forceLogoutUser = (id) => {
  return api.getApi().post(api.getBaseUrl() + "users/" + id + "/force-logout");
};

export const setUserActive = (id, isActive) => {
  return api
    .getApi()
    .put(api.getBaseUrl() + "users/" + id + "/active", { isActive });
};
